import { Controller } from "stimulus";
import $ from 'jquery'
export default class extends Controller {
  static values = {
    url: String
  }

  show(event){
    event.stopImmediatePropagation()
    $.ajax({
      url: this.urlValue,
      success: function(response){
        $('#modal-body').html(response);
        $('#statistics_modal').modal('show');
      }
    });
  }
}
